import * as angular from 'angular';

interface ElementReadyAttributes extends angular.IAttributes {
  elementReady: any;
}

export default angular.module('aps.directives.elementReady', [])
  .directive('elementReady', ($parse: angular.IParseService) => {
    return {
      restrict: 'A',
      link: (scope: angular.IScope,
             element: angular.IAugmentedJQuery,
             attributes: ElementReadyAttributes) => {
        var func = $parse(attributes.elementReady);
        func(scope);
      }
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/directives/element-ready.ts